module.exports = __webpack_public_path__ + "img/game-board-simple.9ab7d84f.svg";